function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.05 15.999l-.127-.002a.963.963 0 01-.708-1.505l4.39-6.309a.322.322 0 000-.366l-4.39-6.312A.96.96 0 017.793.412l4.387 6.309c.533.77.533 1.788 0 2.558l-4.388 6.309a.962.962 0 01-.869.409zm-6.41-.32a.638.638 0 01-.525-1.002l4.388-6.31a.643.643 0 000-.733L.115 1.325A.64.64 0 01.64.32h2.142c.21 0 .405.102.525.274l4.39 6.31c.456.66.456 1.533 0 2.192l-4.39 6.31a.643.643 0 01-.525.274z"
});

function SvgHappyDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 16"
  }, props), _ref);
}

export default SvgHappyDoubleArrow;